/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  account: Object,
  user: Object,
  form: TypeForm,
} & TranslatorProps;

@translate()
@observer
export default class RemoveUserAccessForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, user, account, form }: TypeProps = this.props;

    const details: Array<*> = [
      [t('general:trading_account'), account.name],
      [t('general:trading_accounts.labels.number'), account.account_no],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:trading_accounts.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('selectUser.users')}
            endpoint={`accounts/${account.id}/users`}
            enableSearch={true}
            heading={form.$('selectUser').label}
            searchKeys={['first_name', 'last_name']}
            valueKey="id"
            primaryLiteral={(item: Object) => `${item.first_name} ${item.last_name}`}
            secondaryLiteral={(item: Object) => (
              <React.Fragment>
                Current role: <b>{t(`general:roles.${item.role_id}`)}</b>
              </React.Fragment>
            )}
            customResponse={(response: Object) => {
              let arr: Array<Object> = [];

              for (const key: string in response) {
                if (Object.prototype.hasOwnProperty.call(response, key)) {
                  arr = arr.concat(response[key]);
                }
              }

              return arr;
            }}
          />
          <ActionDrawerBlock gutters={true} padding={true} heading={form.$('removeReason').label}>
            <ElectroSelectWithOther
              field={form.$('removeReason.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
              selectUp={true}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.remove_user_plural')} />
      </React.Fragment>
    );
  }
}
